/**
 * Parse API datetime as local wall-clock (avoids IST/UTC shift in UI).
 */
export const parseApiDateTime = (dateTimeStr, attendanceDate = '') => {
  if (!dateTimeStr) return '';
  const raw = String(dateTimeStr).trim();
  const match = raw.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
  if (match) return `${match[1]}T${match[2]}`;
  const timeMatch = raw.match(/(\d{2}:\d{2})/);
  if (timeMatch && attendanceDate) return `${attendanceDate}T${timeMatch[1]}`;
  return '';
};

export const formatTimeFromApi = (dateTimeStr, attendanceDate = '') => {
  const stored = parseApiDateTime(dateTimeStr, attendanceDate);
  if (!stored) return '-';
  if (stored.includes('T')) return stored.split('T')[1]?.slice(0, 5) || '-';
  return stored.slice(0, 5);
};

export const formatDateFromApi = (dateStr) => {
  if (!dateStr) return '-';
  const datePart = String(dateStr).split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return datePart;
  return new Date(y, m - 1, d).toLocaleDateString('en-IN');
};
